// extracted by mini-css-extract-plugin
module.exports = {"root":"OrgAssessmentHistory_root__1Vnzi","picker-shell":"OrgAssessmentHistory_picker-shell__2TfaW"};